import React, { Component } from 'react';
import moment from 'moment';
import './LineChart.css';
import { D3Chart } from './D3Chart';

export class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPoints: [],
      unit: '',
      reportUnit: '',
    };
    this.ref = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.dataPoints) {
      const dataPoints = nextProps.dataPoints.map((d) => [moment(d.x), d.baseline, d.target, d.actual]);
      const { unit, reportUnit } = nextProps;

      return {
        ...prevState,
        dataPoints,
        unit,
        reportUnit,
      };
    }
    return { ...prevState };
  }

  componentDidMount() {
    const node = this.ref.current;
    const { dataPoints, unit, reportUnit } = this.state;
    this.chart = new D3Chart(node, dataPoints, unit, reportUnit);
  }

  componentDidUpdate() {
    const { dataPoints, unit, reportUnit } = this.state;
    this.chart.update(dataPoints, unit, reportUnit);
  }

  render() {
    return <div className="line-graph" ref={this.ref} />;
  }
}
